/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserItemDto } from './userItemDto';


export interface EmailItemDto { 
    id: string;
    user?: UserItemDto;
    subject: string;
    emailType: EmailItemDto.EmailTypeEnum;
    recipients: Array<string>;
    cc?: Array<string>;
    isSent: boolean;
    created: string;
}
export namespace EmailItemDto {
    export type EmailTypeEnum = 'INSPECTION' | 'REPAIR_TASK' | 'MAINTENANCE_TIMER';
    export const EmailTypeEnum = {
        Inspection: 'INSPECTION' as EmailTypeEnum,
        RepairTask: 'REPAIR_TASK' as EmailTypeEnum,
        MaintenanceTimer: 'MAINTENANCE_TIMER' as EmailTypeEnum
    };
}


